import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Mobile = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M10 9C10 6.23858 12.2386 4 15 4H25C27.7614 4 30 6.23858 30 9V31C30 33.7614 27.7614 36 25 36H15C12.2386 36 10 33.7614 10 31V9ZM15 6C13.3431 6 12 7.34315 12 9V31C12 32.6569 13.3431 34 15 34H25C26.6569 34 28 32.6569 28 31V9C28 7.34315 26.6569 6 25 6H15Z"
                fill={props.color ? props.color : "white"} />
            <path d="M20 26.5C18.6193 26.5 17.5 27.6193 17.5 29C17.5 30.3807 18.6193 31.5 20 31.5C21.3807 31.5 22.5 30.3807 22.5 29C22.5 27.6193 21.3807 26.5 20 26.5Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Mobile;
